<template>
  <div class="signin-activity-canvas">
    <div class="main-canvas">
      <!-- 打码量 & 存款 -->
      <div class="current-info">
        <div class="info">
          <div>
            <span class="info-lab">有效打码量 :</span>
            <span v-if="betAmount<betAmountRule">{{betAmount}}/{{betAmountRule}}</span>
            <span v-else>已完成</span>
          </div>
          <div>
            <span class="info-lab">存款累计 :</span>
            <span v-if="depositAmount<depositAmountRule">{{depositAmount}}/{{depositAmountRule}}</span>
            <span v-else>已完成</span>
          </div>
        </div>
        <div class="refresh-btn" @click="updateInfoHandler()"></div>
      </div>
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="$emit('closeWindow')"></div>
      <!-- 规则 & 奖励 -->
      <div class="top-canvas">
        <!-- 规则 -->
        <div class="rules-canvas">
          <div class="rules-info" v-html="rulesInfo"></div>
        </div>
        <!-- 奖励 -->
        <div class="prize-canvas">
          <div class="prize-status-info">
            <div
              class="treasure-box"
              :class="'treasure-s'+(treasureStatus == 0 ? curstatus ? 0 : 2 : treasureStatus)"
              @click="getOtherPrizeHandler()"
            ></div>
            <div class="treasure-info">{{nextTreasureInfo}}</div>
          </div>
        </div>
      </div>
      <!-- 签到 & 兑换 -->
      <div class="content-canvas">
        <signIn-comp
          :class="{'hide-height':activityModal == 1}"
          v-bind:signInData="signInData"
          v-bind:levelTipVisible="leveltip"
          v-bind:userLevel="userLevel"
          v-bind:joinLevel="joinLevel"
          v-bind:isloading="isfresh"
          v-bind:curstatus="curstatus"
          v-on:compGetPrize="getPrizeHanlder($event)"
          v-on:backHome="backHomeHandler()"
        />
        <integral-comp
          :class="{'hide-height':activityModal == 0}"
          v-bind:cardList="cardData"
          v-bind:currentPoint="currentPoint"
          v-bind:curPage="curPage"
          v-bind:totalPage="totalPage"
          v-on:exchangePoint="exchangeHandler($event)"
          v-on:prePage="leftActionHandler()"
          v-on:nextPage="rightActionHandler()"
        />
      </div>
      <!-- 组件切换按钮 -->
      <div class="components-btn-canvas">
        <span
          class="comp-btn"
          :class="{'comp-action-btn' : activityModal==0}"
          @click="switchCompHandler(0)"
        >签到</span>
        <span
          class="comp-btn"
          :class="{'comp-action-btn' : activityModal==1}"
          @click="switchCompHandler(1)"
        >积分兑换</span>
      </div>
    </div>

    <!-- 动画 -->
    <div class="animation-canvas" v-show="animationWindow">
      <!-- 额外奖励 -->
      <div
        class="animation-box treasure-img"
        :class="{'bounceIn':treasureAni}"
        v-show="treasureAni"
      >
        <div class="info-tip">
          <div class="lab-box">
            <div class="lab">¥{{curOtherPrizeMoney}}现金</div>
            <div class="lab">{{curOtherPrizeScore}}积分</div>
          </div>
        </div>
      </div>
      <!-- 积分奖励 -->
      <div class="animation-box prize-img" :class="{'bounceIn':prizeAni}" v-show="prizeAni">
        <div class="info-tip">
          <div class="lab-box">
            <div class="lab">¥{{curPrizeMoney}}现金</div>
            <div class="lab">{{curPrizeScore}}积分</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import signInComp from "./components/signIn/signIn-comp";
import integralComp from "./components/integral/integral-comp";
import { commonApi } from "@/common/index";

export default {
  name: "signInIndex",
  components: {
    signInComp,
    integralComp
  },
  data() {
    return {
      bonusId: 0,
      logId: null,
      leveltip: false,
      userLevel: 0,
      joinLevel: 0,

      activityModal: 0, // 0-签到，1-积分
      treasureStatus: 0, // 0-待领取，1-已领取，2-不可领取
      nextTreasureInfo: "",
      rulesInfo: "",
      currentPoint: 0, // 当前积分

      // 签到列表
      signInData: [],
      // 兑换列表
      cardData: [],
      // 打码量
      betAmount: 0,
      betAmountRule: 0,
      // 存款累计
      depositAmount: 0,
      depositAmountRule: 0,
      curstatus: false,

      // 刷新
      isfresh: false,
      isfreshInfo: false,

      // 当前奖金&积分
      curPrizeMoney: 0,
      curPrizeScore: 0,
      // 当前额外奖金&积分
      curOtherPrizeMoney: 0,
      curOtherPrizeScore: 0,

      animationWindow: false,
      treasureAni: false,
      prizeAni: false,
      // 頁數
      originData: {},
      curPage: 1,
      totalPage: 1
    };
  },
  methods: {
    // 切换组件
    switchCompHandler(modal) {
      this.activityModal = modal;
    },
    // 领取簽到奖励
    receivePrizeeHandler(m, s) {
      this.curPrizeMoney = m;
      this.curPrizeScore = s;
      this.animationWindow = true;
      this.prizeAni = true;

      setTimeout(() => {
        this.animationWindow = false;
        this.prizeAni = false;
      }, 4 * 1000);
    },
    // 领取额外奖励
    receiveTreasureHandler() {
      this.animationWindow = true;
      this.treasureAni = true;

      setTimeout(() => {
        this.animationWindow = false;
        this.treasureAni = false;
      }, 4 * 1000);
    },

    // 获取签到活动信息（初始化）
    getSignInActivityBonusInfoHandler() {
      // 获取签到信息
      commonApi.DEPOSIT.signInActivityBonusInfo().then(data => {
        let dataInfo = data["data"]["data"];
        this.originData = dataInfo;

        this.bonusId = dataInfo["bonusId"];
        this.leveltip = !dataInfo["vipJoinStatus"];
        this.userLevel = dataInfo["userLevel"];
        this.joinLevel = Number(dataInfo["vipList"][0]);
        this.rulesInfo = dataInfo["description"];
        this.currentPoint = dataInfo["userPoint"];
        this.initSignInDataHandler(dataInfo);
        this.initCardDataHandler(dataInfo);
      });
    },

    // 初始化签到数据
    initSignInDataHandler(dataInfo) {
      let sd = [];
      dataInfo["userLogList"].forEach((item, index) => {
        let dayData = {};
        switch (index) {
          case 0:
            dayData["name"] = "第一天";
            break;
          case 1:
            dayData["name"] = "第二天";
            break;
          case 2:
            dayData["name"] = "第三天";
            break;
          case 3:
            dayData["name"] = "第四天";
            break;
          case 4:
            dayData["name"] = "第五天";
            break;
          case 5:
            dayData["name"] = "第六天";
            break;
          case 6:
            dayData["name"] = "第七天";
            break;
          default:
            break;
        }
        dayData["isCurDay"] = item["currentDay"];
        dayData["prizeStatus"] = Number(item["isBonus"]);
        dayData["money"] = dataInfo["cndList"][index]["giveAmount"];
        dayData["score"] = dataInfo["cndList"][index]["givePoint"];

        if (item["currentDay"]) {
          this.betAmount = item["currentBetflow"];
          this.betAmountRule = item["targetBetflow"];
          this.depositAmount = item["currentDeposit"];
          this.depositAmountRule = item["targetDeposit"];
          this.curstatus =
            this.betAmount >= this.betAmountRule &&
            this.depositAmount >= this.depositAmountRule;

          this.curOtherPrizeMoney = dataInfo["cndList"][index]["otherAmount"];
          this.curOtherPrizeScore = dataInfo["cndList"][index]["otherPoint"];

          this.logId = item["id"];

          this.treasureStatus =
            Number(dataInfo["cndList"][index]["hasOtherBonus"]) == 1
              ? Number(item["isOtherBonus"])
              : 2;
          if (this.treasureStatus == 0) {
            if (
              this.betAmount >= this.betAmountRule &&
              this.depositAmount >= this.depositAmountRule
            ) {
              this.nextTreasureInfo = "领取";
            } else {
              this.nextTreasureInfo =
                "下一次额外奖励：第" + (index + 1) + "天签到成功";
            }
          } else {
            let dayNum = -1;
            // 计算下一次额外奖励
            for (let i = index + 1; i < 7; i++) {
              if (Number(dataInfo["cndList"][i]["hasOtherBonus"]) == 1) {
                dayNum = i;
                break;
              }
            }

            if (dayNum == -1) {
              this.nextTreasureInfo = "暂无";
            } else {
              this.nextTreasureInfo =
                "下一次额外奖励：第" + (dayNum + 1) + "天签到成功";
            }
          }
        }

        sd.push(dayData);
      });

      this.signInData = sd;
    },

    // 初始化积分兑换
    initCardDataHandler(dataInfo) {
      let cd = [];
      if (dataInfo["pointList"].length == 0) {
        this.cardData = [];
      } else {
        this.totalPage =
          dataInfo["pointList"].length % 6 == 0
            ? dataInfo["pointList"].length / 6
            : parseInt(dataInfo["pointList"].length / 6) + 1;

        for (let i = (this.curPage - 1) * 6; i < this.curPage * 6; i++) {
          let cardData = {};
          if (i < dataInfo["pointList"].length) {
            cardData["id"] = dataInfo["pointList"][i]["id"];
            cardData["money"] = dataInfo["pointList"][i]["giveAmount"];
            cardData["score"] = dataInfo["pointList"][i]["needPoint"];
            cardData["condition"] =
              dataInfo["pointList"][i]["betflowMultiple"] + "倍流水";

            cd.push(cardData);
          } else {
            cd.push({});
          }
        }

        this.cardData = cd;
      }
    },
    // 左側切換
    leftActionHandler() {
      if (this.curPage <= 1) {
        return;
      }
      this.curPage -= 1;
      let cd = [];

      for (let i = (this.curPage - 1) * 6; i < this.curPage * 6; i++) {
        let cardData = {};
        if (i < this.originData["pointList"].length) {
          cardData["id"] = this.originData["pointList"][i]["id"];
          cardData["money"] = this.originData["pointList"][i]["giveAmount"];
          cardData["score"] = this.originData["pointList"][i]["needPoint"];
          cardData["condition"] =
            this.originData["pointList"][i]["betflowMultiple"] + "倍流水";

          cd.push(cardData);
        } else {
          cd.push({});
        }

        this.cardData = cd;
      }
    },
    // 右側切換
    rightActionHandler() {
      if (this.curPage >= this.totalPage) {
        return;
      }
      this.curPage += 1;
      let cd = [];

      for (let i = (this.curPage - 1) * 6; i < this.curPage * 6; i++) {
        let cardData = {};
        if (i < this.originData["pointList"].length) {
          cardData["id"] = this.originData["pointList"][i]["id"];
          cardData["money"] = this.originData["pointList"][i]["giveAmount"];
          cardData["score"] = this.originData["pointList"][i]["needPoint"];
          cardData["condition"] =
            this.originData["pointList"][i]["betflowMultiple"] + "倍流水";

          cd.push(cardData);
        } else {
          cd.push({});
        }

        this.cardData = cd;
      }
    },
    // 更新进度
    updateActivityInfo() {
      commonApi.DEPOSIT.updateSignInInfo({
        bonusId: this.bonusId,
        logId: this.logId ? this.logId : ""
      }).then(data => {
        setTimeout(() => {
          this.isfreshInfo = false;
        }, 10 * 1000);

        this.$message({
          message: "刷新成功！",
          type: "success",
          duration: 5000
        });

        let info = data.data.data;
        this.betAmount = info["currentBetflow"];
        this.betAmountRule = info["targetBetflow"];
        this.depositAmount = info["currentDeposit"];
        this.depositAmountRule = info["targetDeposit"];

        // 满足条件时，刷新数据
        if (
          this.betAmount >= this.betAmountRule &&
          this.depositAmount >= this.depositAmountRule
        ) {
          this.getSignInActivityBonusInfoHandler();
        }
      });
    },
    // 更新操作
    updateInfoHandler() {
      if (this.isfreshInfo) {
        this.$message({
          message: "刷新过于频繁，请稍后再试！",
          type: "warning"
        });
        return;
      }

      this.isfreshInfo = true;
      this.updateActivityInfo();
    },
    // 领取今日奖励
    getPrizeHanlder(e) {
      if (this.isfresh) {
        return;
      }

      if (e.status != 0) {
        return;
      }

      this.isfresh = true;
      commonApi.DEPOSIT.getSignInPrizeHandler({
        bonusId: this.bonusId,
        logId: this.logId ? this.logId : ""
      }).then(data => {
        this.isfresh = false;
        if (data["data"]["code"] != 200) {
          this.$message({
            message: data["data"]["msg"],
            type: "warning"
          });
        } else {
          // 領取成功
          this.receivePrizeeHandler(e.m, e.s);
          this.getSignInActivityBonusInfoHandler();
        }
      });
    },
    // 领取额外奖励
    getOtherPrizeHandler() {
      if (this.isfresh) {
        return;
      }

      if (this.treasureStatus != 0) {
        return;
      }

      if (!this.curstatus) {
        return;
      }

      this.isfresh = true;
      commonApi.DEPOSIT.getOtherPrizeHandler({
        logId: this.logId ? this.logId : ""
      }).then(data => {
        this.isfresh = false;
        if (data["data"]["code"] != 200) {
          this.$message({
            message: data["data"]["msg"],
            type: "warning"
          });
        } else {
          this.treasureStatus = 1;
          this.receiveTreasureHandler();
        }
      });
    },
    // 积分兑换
    exchangeHandler(e) {
      if (this.isfresh) {
        return;
      }

      this.isfresh = true;
      commonApi.DEPOSIT.exchangeScoreHandler({ pointId: e.toString() }).then(
        data => {
          this.isfresh = false;
          if (data["data"]["code"] != 200) {
            this.$message({
              message: data["data"]["msg"],
              type: "warning"
            });
          } else {
            // 兑换成功 刷新积分
            this.getSignInActivityBonusInfoHandler();
          }
        }
      );
    },
    // 返回首页
    backHomeHandler() {
      this.$emit("closeWindow");
      this.$router.push({ path: "/" });
    }
  },
  created() {
    this.getSignInActivityBonusInfoHandler();
  }
};
</script>

<style lang="scss">
.el-message {
  z-index: 4200 !important;
}

.signin-activity-canvas {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 3000;
  user-select: none;

  // 主界面
  .main-canvas {
    transform: scale(0.75);
    position: relative;
    width: 1362px;
    height: 880px;
    background: url("./img/main-bg.png") no-repeat center center;
    left: 50%;
    top: 50%;
    margin-left: -681px;
    margin-top: -440px;

    // 打码量 & 存款
    .current-info {
      position: absolute;
      top: 45px;
      left: 120px;
      width: auto;
      height: 50px;

      .info {
        float: left;
        margin-right: 15px;
      }

      .info > div {
        height: 25px;
        line-height: 25px;
        font-size: 14px;
        color: #9789cd;

        .info-lab {
          display: inline-block;
          width: 80px;
          text-align: right;
        }
      }

      .refresh-btn {
        float: right;
        margin-top: 15px;
        width: 20px;
        height: 20px;
        background: url("./img/refresh-btn.png") -10px -10px;
        cursor: pointer;
      }

      .refresh-btn:hover {
        background: url("./img/refresh-btn.png") -50px -10px;
      }
    }

    // 关闭按钮
    .close-btn {
      position: absolute;
      top: 48px;
      left: 1180px;
      width: 40px;
      height: 40px;
      background: url("./img/close-btn.png") -10px -10px;
      cursor: pointer;
    }

    .close-btn:hover {
      background: url("./img/close-btn.png") -70px -10px;
    }

    // 规则 & 奖励
    .top-canvas {
      position: absolute;
      top: 126px;
      left: 105px;
      width: 1152px;
      height: 153px;

      .rules-canvas {
        float: left;
        width: 576px;
        height: 153px;
        background: url("./img/rules-bg.png") no-repeat center center;
        background-size: cover;

        .rules-info {
          overflow-y: scroll;
          width: 457px;
          height: 97px;
          margin-top: 25px;
          margin-left: 93px;
          color: #b8a0ff;
          font-family: "PingFangSC-Regular";
          font-size: 14px;
          line-height: 20px;
        }

        .rules-info::-webkit-scrollbar {
          display: none;
        }
      }

      .prize-canvas {
        float: right;
        width: 576px;
        height: 153px;
        background: url("./img/prize-bg.png") no-repeat center center;
        background-size: cover;

        .prize-status-info {
          position: relative;
          width: 501px;
          height: 137px;
          margin-top: 8px;
          margin-left: 8px;

          .treasure-box {
            width: 265px;
            height: 134px;
            margin: 10px auto 0px auto;
            cursor: pointer;
          }

          .treasure-s0 {
            background: url("./img/treasure-s0.png") no-repeat center center;
          }
          .treasure-s1 {
            background: url("./img/treasure-s1.png") no-repeat center center;
          }
          .treasure-s2 {
            background: url("./img/treasure-s2.png") no-repeat center center;
          }

          .treasure-info {
            position: absolute;
            width: 100%;
            height: 30px;
            line-height: 30px;
            background: url("./img/treasure-info-bg.png") no-repeat center
              center;
            bottom: 1px;
            text-align: center;
            font-family: "PingFangSC-Regular";
            font-size: 12px;
            color: #bbabea;
          }
        }
      }
    }

    // 签到 & 兑换
    .content-canvas {
      position: absolute;
      top: 278px;
      left: 105px;
      width: 1152px;
      height: 400px;

      .hide-height {
        display: none;
      }
    }

    // 组件切换按钮
    .components-btn-canvas {
      position: absolute;
      left: 50%;
      margin-left: -191px;
      top: 733px;
      width: 382px;
      height: 70px;
      background: url("./img/comp-btn.png") no-repeat center center;

      .comp-btn {
        float: left;
        width: 191px;
        height: 74px;
        line-height: 74px;
        color: #2a2749;
        font-size: 24px;
        text-align: center;
        cursor: pointer;
        opacity: 0.6;
      }

      .comp-action-btn {
        color: #fffadb;
        opacity: 1;
      }
    }
  }

  // 动画效果
  .animation-canvas {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 4000;

    .animation-box {
      position: absolute;
      width: 300px;
      height: 220px;
      top: 50%;
      left: 50%;
      margin-left: -150px;
      margin-top: -110px;
    }

    // 登录奖励
    .prize-img {
      background: url("./img/prize-img.png") no-repeat center center;

      .info-tip {
        position: relative;
        width: 106px;
        height: 73px;
        background: url("./img/info-tip-bg.png") no-repeat center center;
        margin-left: 50px;
        margin-top: -35px;

        .lab-box {
          position: absolute;
          width: 86px;
          height: 46px;
          margin-top: 10px;
          margin-left: 10px;

          .lab {
            width: 100%;
            height: 23px;
            line-height: 23px;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            color: #1f0052;
            font-family: "PingFangSC-Regular";
          }
        }
      }
    }

    // 额外奖励
    .treasure-img {
      background: url("./img/treasure-img.png") no-repeat center center;

      .info-tip {
        position: relative;
        width: 106px;
        height: 73px;
        background: url("./img/info-tip-bg.png") no-repeat center center;
        margin-left: 50px;
        margin-top: -75px;

        .lab-box {
          position: absolute;
          width: 86px;
          height: 46px;
          margin-top: 10px;
          margin-left: 10px;

          .lab {
            width: 100%;
            height: 23px;
            line-height: 23px;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            color: #1f0052;
            font-family: "PingFangSC-Regular";
          }
        }
      }
    }
  }

  .bounceIn {
    animation-duration: 1s;
    animation-name: bounceIn;
  }

  @keyframes bounceIn {
    from,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 1;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    to {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build08/components/signInActivity/signInIndex.vue